import Header from '@editorjs/header';
import List from '@editorjs/list';
import Paragraph from '@editorjs/paragraph';
import Underline from '@editorjs/underline';
import Quote from '@editorjs/quote';
import EditorJS from '@editorjs/editorjs';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Contract } from 'src/app/models/contract.model';
import { ContractService } from 'src/app/services/contract_service.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogClose } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'contract',
    templateUrl: './contract.component.html',
    styleUrls: ['./contract.component.scss'],
    imports: [MatButton, MatDialogClose]
})
export class ContractComponent implements OnInit {
    contract!: Contract;
    editor!: EditorJS;

    loadingContract = false;
    displayPinError = false;
    pin = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { contractId: string },
        private contractService: ContractService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        public dialog: MatDialog,
    ) {}

    ngOnInit(): void {
        if (this.data.contractId != null) {
            this.getContractById();
        } else {
            this.router.navigate(['home']);
        }
    }

    getContractById(): void {
        this.contractService.get([this.data.contractId], new Map()).subscribe((contract: any) => {
            this.contract = contract;
            this.clearEditor();
            this.setEditorBlocks();
        });
    }

    getContract(): void {
        this.loadingContract = true;

        this.contractService
            .get([this.data.contractId], new Map())
            .subscribe((contract: any) => {
                this.contract = contract;
                this.loadingContract = false;
            }, _ => {
                this.loadingContract = false;
            });
    }

    setEditorBlocks(): void {
        this.clearEditor();

        const body = JSON.parse(this.contract.body);

        this.editor = new EditorJS({
            holder: 'editor-js',
            tools: { Header, List, Paragraph, Quote, Underline, image: SimpleImage },
            data: body,
            readOnly: true,
        });
    }

    clearEditor(): void {
        const editor = document.getElementById('editor-js');

        if (editor) {
            editor.innerHTML = '';
        }
    }
}

class SimpleImage {
  render(){
    return document.createElement('input');
  }

  save(blockContent: { value: any; }){
    return {
      url: blockContent.value
    }
  }
}